module.exports = __webpack_public_path__ + "img/log-out-icon.ac721900.png";